<div class="content nova-body-medium">
  <div class="esign-card">Info bar content.</div>
  <div class="esign-card">Info bar content.</div>
</div>
<div class="mobile-content">Mobile info bar content.</div>
